import { type TableHeaderRow } from '@shared/table-generator';

import { MINIMUM_DISPLAY_CHOICE } from '../../constants';

export function ItemAnalysisResponseStatisticsTableHeader(choice: number): TableHeaderRow[] {
  const choiceNumber = choice === 0 ? MINIMUM_DISPLAY_CHOICE : choice;
  return [
    {
      children: [
        {
          id: 'no',
          children: 'No.',
          align: 'center',
          rowSpan: 2,
          width: 64,
        },
        {
          id: 'questionId',
          children: 'QID',
          align: 'center',
          rowSpan: 2,
          width: 200,
        },
        {
          id: 'answer',
          children: 'Answer',
          align: 'center',
          rowSpan: 2,
          width: 100,
        },
        {
          id: 'numberOfPassAndFail',
          children: 'NPF',
          align: 'center',
          rowSpan: 2,
          width: 90,
        },
        {
          id: 'numberExaminees',
          children: 'จำนวนคน',
          align: 'center',
          colSpan: choiceNumber,
        },
        {
          id: 'percentage',
          children: 'เปอร์เซ็นต์ (%)',
          align: 'center',
          colSpan: choiceNumber,
        },
        {
          id: 'pCalculated',
          children: 'P Cal',
          align: 'center',
          rowSpan: 2,
          width: 90,
        },
      ],
    },
    {
      children: [
        ...Array.from({ length: choiceNumber }, (_, i) => ({
          id: `passS${i}`,
          children: `S${i}`,
          align: 'center' as const,
          width: 90,
        })),
        ...Array.from({ length: choiceNumber }, (_, i) => ({
          id: `failS${i}`,
          children: `S${i}`,
          align: 'center' as const,
          width: 90,
        })),
      ],
    },
  ];
}
